import { memo } from 'react';

import { Flex, type FlexProps } from '../flex/flex';

type VStackProps = Omit<FlexProps, 'direction'>;

export const VStack = memo((props: VStackProps) => {
  const { align = 'start', max } = props;
  return <Flex {...props} max={max} direction="column" align={align} />;
});
